<div class="container d-none d-lg-block pt-3">
  <div class="rewards-back-button cursor-pointer" (click)="goBack()">
    <span class="material-icons align-middle fw-bold text-white">navigate_before</span>
  </div>
</div>

<!-- Points Summary -->
<fgb-points-summary-bar
  [backButtonLink]="marketplaceItemType.backLink"
  [marketplaceItemGroup]="marketplaceItemType.group"
></fgb-points-summary-bar>

<!-- Details -->
<fgbcl-marketplace-details [itemId]="id" [actionLabels]="actionLabels"></fgbcl-marketplace-details>
